import { useLocation, useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';

const Filters = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Parse the URL to get active filters
  const params = new URLSearchParams(location.search);
  const activeFilters = [];
  if (params.get('isCoach') === 'true') {
    activeFilters.push('Is a Coach');
  }

  // Function to remove a filter from the URL
  const removeFilter = (filter) => {
    if (filter === 'Is a Coach') {
      params.delete('isCoach');
    }
    navigate({ search: params.toString() });
  };

  return (
    <div className="flex gap-2 mb-4 pr-0 items-center">
      {activeFilters.map((filter) => (
        <FilterBadge
          key={filter}
          label={filter}
          onRemove={() => removeFilter(filter)}
        />
      ))}
    </div>
  );
};

const FilterBadge = ({ label, onRemove }) => {
  return (
    <Badge variant="outline" className="py-1 px-4 pr-1 text-xs">
      {label}
      <X
        className="h-4 w-4 ml-2 opacity-50 cursor-pointer hover:opacity-100"
        onClick={onRemove}
      />
    </Badge>
  );
};

export default Filters;
